import { render, staticRenderFns } from "./VehicleIssueTrends.vue?vue&type=template&id=a1de71b8&scoped=true&"
import script from "./VehicleIssueTrends.vue?vue&type=script&lang=js&"
export * from "./VehicleIssueTrends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1de71b8",
  null
  
)

export default component.exports